import React, { useState, useEffect, useMemo } from 'react';

import dayjs from 'dayjs'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import styled from 'styled-components'
import { useTable, usePagination, useSortBy } from 'react-table'

import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";

import ReactLoading from 'react-loading';
import optc from '../optc.json'

import { parseVehData, evalStats } from '../helpers/serviceCurveHelpers.js'

import { getHistory, getGroups, getCurveStats, getUserAgency } from '../API';

import {
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  Tooltip,
  Legend
} from 'recharts';

import OpChecklist from '../components/CourbeService/OpChecklist.js'

import { useTranslation } from "react-i18next";

// date-time config
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
const tz = "America/Toronto"
dayjs.extend(utc);
dayjs.extend(timezone);


const Styles = styled.div
  `
  padding: 1rem;

  .pagination {
    padding: 0.5rem;
  }

  th

  td { background-color: white; }

  
`

function Table({ columns, data }) {

  const [t] = useTranslation('common');

  const [selectedRow, setSelectedRow] = useState(-1);

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active pagconst [cellValue, setCellValue] = useState('');e

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },

      sortTypes: {
        custom: (rowA, rowB, columnId) => {
          const a = rowA.values[columnId];
          const b = rowB.values[columnId];

          if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
          }
          return a.localeCompare(b);
        }
      },
    },
    useSortBy,
    usePagination,
  )

  const handleRowHover = (e) => {
    setSelectedRow(e.id);
  }

  const handleMouseOut = () => {
    setSelectedRow(-1);
  }

  // Render the UI for your table
  return (


    <>
      <table className="table" {...getTableProps()}>
        <thead style={{ textAlign: 'center' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {

            prepareRow(row);

            return (
              <tr
                onMouseMove={(e) => handleRowHover(row)} onMouseOut={() => handleMouseOut()}
                {...row.getRowProps()}
              >
                {row.cells.map(cell => {
                  return <td
                    style={{ backgroundColor: row.id == selectedRow && cell.column.Header !== 'Ligne' ? '#D3D3D3' : '' }}
                    {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} {t('routeoperation.of')} {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | {t("routeoperation.go")}{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[5, 10, 20, 30].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              {t("routeoperation.show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}


function ServiceCurve() {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  const columns = useMemo(
    () => [
      {
        Header: <p>{t('rtcurve.table.agency')}</p>,
        accessor: 'groupe',
      },
      {
        Header: <div>{t('rtcurve.table.vam1')}<br /><div>{t('rtcurve.table.vam2')}</div></div>,
        accessor: 'maxrtveham',
      },
      {
        Header: <div>{t('rtcurve.table.vop1')}<br /><div>{t('rtcurve.table.vop2')}</div></div>,
        accessor: 'maxrtvehop',
      },
      {
        Header: <div>{t('rtcurve.table.vpm1')}<br /><div>{t('rtcurve.table.vpm2')}</div></div>,
        accessor: 'maxrtvehpm',
      },
      {
        Header: <div>{t('rtcurve.table.pctam')}</div>,
        accessor: 'ampct',
        Cell: props => <div> {(props.value).toFixed(0)}% </div>,
      },
      {
        Header: <div>{t('rtcurve.table.pctop')}</div>,
        accessor: 'oppct',
        Cell: props => <div> {(props.value).toFixed(0)}% </div>,
      },
      {
        Header: <div>{t('rtcurve.table.pctpm')}</div>,
        accessor: 'pmpct',
        Cell: props => <div> {(props.value).toFixed(0)}% </div>,
      },
    ],
    []
  )


  const [selectedDay, setSelectedDay] = useState('');

  const [groups, setGroups] = useState('');
  const [prevGroups, setPrevGroups] = useState('');
  const [date, setDate] = useState(new Date());
  //const [todayFormat, setTodayFormat] = useState('');
  const [selectedDayFormat, setSelectedDayFormat] = useState('');
  const [vehDataRealtime, setVehDataRealtime] = useState('');

  const [userAgency, setUserAgency] = useState('');

  const [curveStats, setCurveStats] = useState([]);

  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKey1, setRefreshKey1] = useState(0);
  const [refreshKey2, setRefreshKey2] = useState(0);

  const [firstLoad, setFirstLoad] = useState(1);

  useEffect(() => {

    getUserAgency().then((res) => {

      setUserAgency(optc.optc.find((e) => e.operateur == res[0]).groupe);

      //filter active agencies on graph
      getGroups().then((response) => {
        if (prevGroups) {
          response.forEach((e) => {
            if (prevGroups.find((f) => { return e.groupe == f.groupe }).active == true) {
              e.active = true
            } else {
              e.active = false
            }
          })
        } else {
          if (res == 'admin') {
            response.forEach((e) => {
              if (e.groupe == 'stm') {
                e.active = true
              } else {
                e.active = false
              }
            })
          } else {
            response.forEach((e) => {
              if (e.groupe == optc.optc.find((e) => e.operateur == res[0]).groupe) {
                e.active = true
              } else {
                e.active = false
              }
            })
          }
        }
        // Only push Quebec and Ontario operators for now
        let filteredGroups = [];
        response.forEach((e) => {
          if (optc.optc.find((f) => f.groupe == e.groupe).region == "Québec" ||
            optc.optc.find((f) => f.groupe == e.groupe).region == "Ontario") {
            filteredGroups.push(e)
          }
        })
        setGroups(filteredGroups);

        setFirstLoad(0);
        setRefreshKey1(oldKey => oldKey + 1);
      })

    })
  }, [refreshKey])


  //get data for curve
  useEffect(() => {

    if (firstLoad == 0) {

      let previous = dayjs(date).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD') ? 0 : 1;

      groups !== '' ?
        getHistory(date, previous).then((result) => {

          let parseAllR = parseVehData(result);

          const vehDataRealtime = [];

          groups.forEach((a) => {
            vehDataRealtime.push({
              groupe: a.groupe,
              data: parseAllR.filter((e) => { return e.groupe === a.groupe })
            })
          })

          //let todayFormat = dayjs(date).format('YYYY-MM-DD');
          let selectedDayFormat = dayjs(date).format('YYYY-MM-DD');

          setGroups(groups);
          setSelectedDay(date);
          //setTodayFormat(todayFormat);
          setSelectedDayFormat(selectedDayFormat)
          setVehDataRealtime(vehDataRealtime);

          setRefreshKey2(oldKey => oldKey + 1);
        }) : ''
    }

  }, [refreshKey1]);


  //get curve stats after data is downloaded
  useEffect(() => {

    if (firstLoad == 0) {

      let today = new Date();

      let timeFormat = dayjs().format('H');

      //If day is today
      if (vehDataRealtime !== '' && (
        (dayjs(date).format('YYYY-MM-DD') == dayjs(today).format('YYYY-MM-DD')) ||
        (dayjs(date).format('YYYY-MM-DD') == dayjs(today).add(-1, 'day').format('YYYY-MM-DD') && timeFormat >= 0 && timeFormat < 4))
      ) {

        let stats = evalStats(vehDataRealtime);

        const filtered = stats.filter((el) => {
          return groups.some((f) => {
            return f.groupe === el.groupe && f.active === true;
          });
        });

        setCurveStats(filtered);

      } else {

        //If day is before today
        getCurveStats(dayjs(date).format('YYYY-MM-DD')).then((response) => {

          let tableData = [];

          groups.forEach((e) => {
            let groupData = response.filter((f) => { return f.groupe == e.groupe });
            let obj = {
              groupe: e.groupe,
              active: e.active
            }
            groupData.forEach((j) => {
              switch (j.period) {
                case 'am':
                  obj.maxrtveham = j.maxrtveh
                  obj.maxplanveham = j.maxplanveh
                  break;
                case 'offpeak':
                  obj.maxrtvehop = j.maxrtveh
                  obj.maxplanvehop = j.maxplanveh
                  break;
                case 'pm':
                  obj.maxrtvehpm = j.maxrtveh
                  obj.maxplanvehpm = j.maxplanveh
                  break;
              }
              obj.ampct = obj.maxrtveham / (Math.max(obj.maxrtveham, obj.maxrtvehop, obj.maxrtvehpm)) * 100;
              obj.oppct = obj.maxrtvehop / (Math.max(obj.maxrtveham, obj.maxrtvehop, obj.maxrtvehpm)) * 100;
              obj.pmpct = obj.maxrtvehpm / (Math.max(obj.maxrtveham, obj.maxrtvehop, obj.maxrtvehpm)) * 100;
            })
            tableData.push(obj);
          })

          

          // response.forEach((e) => {
          //   let ampct = e.maxrtveham / (Math.max(e.maxrtveham, e.maxrtvehop, e.maxrtvehpm)) * 100;
          //   let oppct = e.maxrtvehop / (Math.max(e.maxrtveham, e.maxrtvehop, e.maxrtvehpm)) * 100;
          //   let pmpct = e.maxrtvehpm / (Math.max(e.maxrtveham, e.maxrtvehop, e.maxrtvehpm)) * 100;
          //   e.ampct = ampct;
          //   e.oppct = oppct;
          //   e.pmpct = pmpct;
          // })

          const filtered = tableData.filter((el) => {
            return groups.some((f) => {
              return f.groupe === el.groupe && f.active === true;
            });
          });

          setCurveStats(filtered);

        })
      }
    }

  }, [refreshKey2]);


  const handleDayClick = (day) => {
    setVehDataRealtime([]);
    setDate(day);
    setPrevGroups(groups);
    setRefreshKey1(oldKey => oldKey + 1);
  }

  const handleCheckToggleOp = (e) => {

    let groupList = [...groups];
    let groupSelected = groupList.find((f) => { return f.groupe == e.target.value });

    if (groupSelected.active == false) {
      groupList.find((f) => { return f.groupe == e.target.value }).active = true
    } else {
      groupList.find((f) => { return f.groupe == e.target.value }).active = false
    }

    setGroups(groupList);
    setRefreshKey2(oldKey => oldKey + 1);
  }


  const CustomTooltip = ({ active, payload }) => {
    if (active) {
      return (
        <div className="custom-tooltip">
          <p className="label">{t('rtcurve.hover.agency')} {payload[0].payload.groupe}<br />
            {/* Date : {payload[0].payload.date} <br /> */}
            {t('rtcurve.hover.time')} {dayjs(payload[0].payload.time).format('HH:mm:ss')}<br />
            {t('rtcurve.hover.online')} {payload[0].payload.veh}</p>
        </div>
      );
    }

    return null;
  };

  return userAgency && vehDataRealtime && vehDataRealtime.length > 0 && selectedDay ? (

    <>

      <div className="row ps-1 pe-1">
        <div className="col-sm">
          <h1 id="page-title" className="display-5">{t('rtcurve.title')}</h1>
        </div>
      </div>

      <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

        <div className="d-flex justify-content-center pt-3">
          <DatePicker
            selected={selectedDay}
            onChange={(date) => handleDayClick(date)}
            locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
            inline
            excludeDateIntervals={[
              {
                start: subDays(new Date('2000-01-01'), 0),
                end: addDays(new Date('2023-07-01'), 0)
              },
              {
                start: subDays(new Date(), 0),
                end: addDays(new Date('2030-12-31'), 0)
              },
            ]}
          />
        </div>

        <div className="row no-gutters pb-3 pt-3">

          <div className="col-lg-3 col-md-4 col-sm-12">
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div className="col-12 overflow-y-scroll border" style={{ backgroundColor: "white", maxHeight: "440px" }}>
                <h5 className="card-subtitle mb-2 text-center">{t('rtcurve.agencies')}</h5>
                <OpChecklist
                  groups={groups}
                  handleToggle={handleCheckToggleOp}
                  properties={optc.optc}
                />
              </div>
            </div>
          </div>


          <div className="col-lg-9 col-md-8 col-sm-12">
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <h4 className="text-center">{selectedDayFormat}</h4>
              <ResponsiveContainer width="100%" height={400}>
                <ScatterChart width={730} height="50%"
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <XAxis
                    type="number"
                    dataKey="time"
                    name='time'
                    domain={[1556438400000, 1556521200000]}
                    tickFormatter={
                      (unixTime) => dayjs(unixTime).format('HH:mm:ss')}
                    ticks={[
                      1556438400000,
                      1556442000000, 1556445600000, 1556449200000, 1556452800000,
                      1556456400000, 1556460000000, 1556463600000, 1556467200000,
                      1556470800000, 1556474400000, 1556478000000, 1556481600000,
                      1556485200000, 1556488800000, 1556492400000, 1556496000000,
                      1556499600000, 1556503200000, 1556506800000, 1556510400000,
                      1556514000000, 1556517600000, 1556521200000

                    ]}
                    angle={-90} dx={-4} textAnchor="end" height={100}
                  />
                  <YAxis yAxisId="left" dataKey="veh" name='véhicules'
                    label={{ value: t('rtcurve.online'), angle: -90, position: 'insideLeft' }} />
                  <ZAxis dataKey="z" range={[10]} />
                  <Tooltip
                    content={<CustomTooltip />}
                  />
                  <Legend formatter={(value, entry, index) =>
                    <span style={{ color: "black" }} className="text-color-class">{value}</span>
                  } />
                  {groups.map((a) => (
                    a.active == true ?
                      <Scatter
                        key={a.groupe}
                        yAxisId="left"
                        name={a.groupe}
                        data={vehDataRealtime.find(f => f.groupe === a.groupe).data}
                        fill={optc.optc.find((e) => e.groupe == a.groupe).color}
                      />
                      : ""
                  )
                  )}
                </ScatterChart>
              </ResponsiveContainer>
            </div>
          </div>

          {curveStats.length>0 ? 
          <div className="col pt-2">
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div id="overflow-table" className="container pt-2 pe-3">
                <div className="row justify-content-center">
                  <div className="col ps-2">
                    <Styles>
                      <Table columns={columns} data={curveStats} />
                    </Styles>
                  </div>
                </div>
              </div>
            </div>
          </div>
          : ''}

        </div>
      </div>
    </>
  ) :
    <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="d-flex justify-content-center">
        <div className="row">
          <div className="col-sm">
            <h1 className="display-5">{t('data.loading')}</h1>
            <div className="d-flex justify-content-center">
              <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
            </div>
          </div>
        </div>
      </div>
    </div>

}

export default ServiceCurve;
